import axios from 'axios';

const selfServiceUrl = window.__CONFIG__.SELF_SERVICE_URL + '/api/request/';

class SelfServiceAPI {

    async getStatusOfUpdate(token, sessionId){     // Get status of "update_data" request (by id)
        return axios({
            method: 'get',
            url: selfServiceUrl + sessionId,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
}

export default new SelfServiceAPI();
